<template>
  <div class="container-fluid">
    <div class="row">
      <div
        :class="getCalcPanelClass()"
        class="calculator"
      >
        <div class="row">
          <div class="col rbcalc-mb-4">
            <error-boundary>
              <control-range
                label="Сумма кредита"
                external-key="amount"
                :measure-unit-title="getCurrencyMeasureUnitTitle"
                :params="getAmountRange"
                :external-handler="setData"
                :default-value="getUserInputByKey('amount')"
              />
            </error-boundary>
          </div>
        </div>
        <error-boundary>
          <control-range
            class="rbcalc-mb-4"
            label="Срок кредита"
            external-key="term"
            :params="getTermsRange"
            :external-handler="setTerm"
            :is-month-to-years="true"
            :default-value="getUserInputByKey('numberOfPayments')"
          />
        </error-boundary>
        <div class="row col">
          <control-checkbox
            v-if="getInsuranceToggle"
            label="Включить страховку в стоимость"
            external-key="insurance"
            :external-handler="setData"
            :default-value="getUserInputByKey('insurance')"
          />
        </div>
        <div class="row d-none d-lg-block d-xl-block ">
          <div class="col disclaimer__left">
            {{ disclaimer }}
          </div>
        </div>
      </div>
      <!-- two rates version -->
      <template v-if="getUserInputByKey('twoRates')">
        <div class="result-spacer d-lg-none" />
        <div
          :class="getResultPanelClass()"
          class="col-lg-5 result-loan"
        >
          <div class="row ie-fix">
            <div class="col-xs-2 col-sm-3 col-md-3 col-lg-3 result__col-title-left">
              <error-boundary>
                <block-legend
                  class-names="legend__value_small-2 legend__value_block"
                >
                  <span>1-й год</span>
                </block-legend>
              </error-boundary>
              <div class="spacer" />
              <error-boundary>
                <block-legend
                  class-names="legend__value_small-2 legend__value_block"
                >
                  <span>со 2-го года</span>
                </block-legend>
              </error-boundary>
            </div>
            <div class="col-xs-5 col-sm-6 col-md-6 col-lg-5 result__col-first">
              <error-boundary>
                <block-legend
                  class-names="legend__value_small-1"
                >
                  <span class="result__col-title-top">Ежемесячный платеж</span>
                </block-legend>
              </error-boundary>
              <error-boundary>
                <block-legend
                  :value="total('getTotal')"
                  class-names="legend__value_medium-2 legend__value_block-center"
                />
              </error-boundary>
              <div class="spacer" />
              <error-boundary>
                <block-legend
                  :value="total('getSecondYearTotal')"
                  class-names="legend__value_medium-2 legend__value_block-center"
                />
              </error-boundary>
            </div>
            <div
              v-if="showRate"
              class="col-xs-5 col-sm-3 col-md-3 col-lg-4 result__col-second"
            >
              <error-boundary>
                <block-legend
                  class-names="legend__value_small-1"
                >
                  <span class="result__col-title-top">Ставка</span>
                </block-legend>
              </error-boundary>
              <error-boundary>
                <block-legend
                  :value="rate('getRate')"
                  class-names="legend__value_medium-2 legend__value_block-center"
                />
              </error-boundary>
              <div class="spacer" />
              <error-boundary>
                <block-legend
                  :value="rate('getSecondYearRate')"
                  class-names="legend__value_medium-2 legend__value_block-center"
                />
              </error-boundary>
            </div>
            <div class="schedule-wraper col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <error-boundary v-if="isShowingCtaButtonControl">
                <control-button
                  class="button--primary"
                  :text="getCtaText"
                  :external-handler="ctaHandler"
                />
              </error-boundary>
              <error-boundary v-if="isShowingDetailsButtonControl">
                <control-button
                  class="button--text"
                  :text="getDetailsText"
                  :external-handler="detailsHandler"
                >
                  <span class="button--icon fa fa-arrow-right" />
                </control-button>
              </error-boundary>
            </div>
          </div>
        </div>
      </template>
      <!--two rates version end-->

      <!--one rate version -->
      <div
        v-if="!getUserInputByKey('twoRates')"
        class="col-lg-5 result"
      >
        <div class="row ie-fix">
          <div class="remove-pad col-xs-12 col-sm-auto col-md-12 col-lg-12">
            <error-boundary>
              <block-legend
                external-key="total"
                description="Ежемесячный платеж"
                :value="total('getTotal')"
                class="sum-value"
              >
                Ежемесячный платеж
              </block-legend>
            </error-boundary>
            <template v-if="showRate">
              <error-boundary>
                <block-legend
                  external-key="rate"
                  :value="'от ' + rate('getRate')"
                >
                  Ставка по кредиту
                </block-legend>
              </error-boundary>
            </template>
          </div>
          <div class="remove-pad col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <error-boundary v-if="isShowingCtaButtonControl">
              <control-button
                external-key="cta_btn"
                class="button--primary"
                :text="getCtaText"
                :external-handler="ctaHandler"
              />
            </error-boundary>
            <error-boundary v-if="isShowingDetailsButtonControl">
              <control-button
                external-key="details_btn"
                class="button--text"
                :text="getDetailsText"
                :external-handler="detailsHandler"
              >
                <span class="button--icon fa fa-arrow-right" />
              </control-button>
            </error-boundary>
          </div>
        </div>
      </div>
      <!--one rate version end-->
    </div>
    <div class="row d-lg-none ">
      <div class="col disclaimer">
        {{ disclaimer }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import wNumb from 'wnumb';
import ErrorBoundary from '@ui/components/ErrorBoundary';
import BlockLegend from '@ui/components/BlockLegend';
import ControlButton from '@ui/components/ControlButton';
import ControlRange from '@ui/components/ControlRange';
import ControlCheckbox from '@ui/components/ControlCheckbox';

export default {
  name: 'LayoutLoan',
  components: {
    ErrorBoundary,
    BlockLegend,
    ControlButton,
    ControlRange,
    ControlCheckbox
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      'getDataByKey',
      'getCurrencyMeasureUnitTitle',
      'getAmountRange',
      'getTermsRange',
      'getUserInputByKey',
      'getCurrencySymbol',
      'getTotal',
      'getRate',
      'getSecondYearRate',
      'getSecondYearTotal',
      'getCtaLink',
      'getCtaText',
      'getDetailsLink',
      'getDetailsText',
      'getInsuranceToggle',
      'getHiddenBlocks'
    ]),
    isShowingDetailsButtonControl() {
      return this.getDetailsLink !== '';
    },
    isShowingCtaButtonControl() {
      return this.getCtaLink !== '';
    },
    disclaimer() {
      if (this.getInsuranceToggle) {
        return 'Не является офертой.';
      }

      return this.getUserInputByKey('insurance')
        ? 'Расчет платежа приведен c учетом финансовой защиты. Не является офертой.'
        : 'Расчет платежа приведен без учета финансовой защиты. Не является офертой.';
    },
    showRate() {
      return !this.getHiddenBlocks.includes('rate');
    }
  },
  methods: {
    ...mapActions([
      'setData',
      'setTerm'
    ]),
    rate(getterName) {
      const rate = this[getterName];
      return rate + "%";
    },
    total(getterName) {
      const numberFormat = wNumb({
        thousand: ' ',
        suffix: ` ${this.getCurrencySymbol}`
      });

      return `${numberFormat.to(this[getterName])}`;
    },
    ctaHandler() {
      window.location.href = this.getCtaLink;
    },
    detailsHandler() {
      window.location.href = this.getDetailsLink;
    },
    isTwoRates(){
      return this.getUserInputByKey('twoRates');
    },
    getCalcPanelClass(){
      return {
        'col-lg-6 calc-panel__small-pad': this.isTwoRates(),
        'col-lg-7': !this.isTwoRates()
      };
    },
    getResultPanelClass(){
      return {
        'col-lg-6 result-panel__small-pad': this.isTwoRates(),
        'col-lg-5': !this.isTwoRates()
      };
    }
  }
};
</script>
<style lang="scss" scoped>
#app {

    & .result-loan {
       & .legend {
          margin-bottom: 0;
       }

       & .button--primary {
           min-width: 100%;
       }
    }

    & .result__col {
      &-title-left {
        margin-top: calcEm(52px);

        & span {
            display: flex;
            height: 36px;
            justify-content: center;
            align-items: center;
            font-size: calcEm(15px);
            background: #F0F0F0;

        }
      }

      &-title-top {
        display: inline-block;
        text-align: center;
        width: 100%;
        height: calcEm(46px);
      }
    }

    & .calculator {
      padding-bottom: 32px;
    }

    & .spacer {
        width: 100px;
        height: calcEm(16px);
    }

    .disclaimer {
        text-align: center;
        color: #737373;
        padding-top: 24px;

        &__left {
            text-align: left;
            color: #737373;
            padding-top: 24px;
        }
    }

    & .result-spacer {
        width: 100%;
        height: 1px;
        border-top: 1px solid $color-grey;
        margin-left: 15px;
        margin-right: 15px;
    }

    & .schedule-wraper {
        margin-top: calcEm(32px);
    }

    @include media-breakpoint-up(xs) {
      /* refactor with https://getbootstrap.com/docs/4.0/utilities/spacing/*/
      & .remove-pad {
        padding-left: 0;
        padding-right: 0;
      }
    }

    @include media-breakpoint-down(sm) {
      & .result__col {
        &-title-left {
          & span {
            height: 46px;
          }
        }
      }
    }

    @include media-breakpoint-down(md) {

      & .calc-panel {
        &__small-pad {
          padding-bottom: calcEm(27px);
        }
      }

      & .result-panel {
        &__small-pad {
          padding-top: calcEm(27px);
        }
      }

      & .result-loan {
        border-left: none;
      }

      & .calculator {
        padding-right: 15px;
      }

      & .result__col {
        &-title-left {
          & span {
            height: 46px;
          }
        }
      }
    }
    @include media-breakpoint-up(lg) {

      & .calc-panel {
        &__small-pad {
          padding-right: calcEm(71px);
        }
      }

      & .result-panel {
        &__small-pad {
          padding-left: calcEm(71px);
        }
      }

      & .result-loan {
        border-left: 1px solid $color-grey;
        border-top: none;
      }

      & .result__col {
        &-title-left {
          padding-right: 0;
        }
        &-second {
          padding-right: 0;
        }
      }

      & .result__col {
        &-title-left {
          & span {
            height: 45px;
          }
        }
      }
    }

    @include media-breakpoint-up(xl) {
      & .result__col {
        &-title-left {
          & span {
            height: 46px;
          }
        }
      }
    }

    @media (max-width: 574px) {

      & .result-loan {
        & .result {
          &__col {

            &-first {
              flex: 0 0 50%;
              max-width: 50%;
              padding-left: calcEm(10px);
              padding-right: calcEm(10px);
            }

            &-second {
              flex: 0 0 25%;
              max-width: 25%;
              padding-left: 0;
              padding-right: calcEm(15px);
              padding-bottom: 0;
            }

            &-title-left {
              flex: 0 0 25%;
              max-width: 25%;
              padding-left: calcEm(15px) ;
              padding-right: 0;
              padding-bottom: 0;
            }
          }
        }
      }
    }

    @media (max-width: 492px) {
        & .result__col-title-left {
            & span {
                font-size: calcEm(12px);
            }
        }
    }

    @media (max-width: 409px) {
        & .result__col-title-left {
            & span {
                font-size: calcEm(10px);
            }
        }
    }

    @media (max-width: 354px) {
        & .result__col-title-left {
            & span {
                font-size: calcEm(9px);
            }
        }
    }
  }
</style>
